import React, {useEffect, useState} from "react";
import {useSearchParams, useNavigate} from 'react-router-dom';
import {useDataWithRoute, useTitleFromComponent} from "../../../utils/hooks";
import {useVsiAppContext} from "../../../stores/VsiApp";
import {VsiBubble, VsiH4} from "../../../styled/App.styled";
import {Card, Spinner} from "reactstrap";
import Grid from "../../../components/Grid";

import VsiLabeledSelect from "../../../components/VsiLabeledSelect";

import {
    allClustersDefs,
    allNodesDefs,
    allPodsDefs,
    allContainersDefs
} from "../../../utils/gridColumnDefs/kubernetes/allUnits";

const allUnits = [
    {value: 'clusters', label: 'Clusters', recordset: 0},
    {value: 'nodes', label: 'Nodes', recordset: 1},
    {value: 'pods', label: 'Pods', recordset: 2},
    {value: 'containers', label: 'Containers', recordset: 3}
];

function returnActiveDef(unit) {
    switch (unit) {
        case 'nodes':
            return allNodesDefs;
        case 'pods':
            return allPodsDefs;
        case 'containers':
            return allContainersDefs;
        case 'clusters':
        default:
            return allClustersDefs;
    }
}

export default function KubernetesAllUnits({title, context}) {
    useTitleFromComponent(`${context} / ${title}`);
    const { theme, client, periodId } = useVsiAppContext();

    const [allDevices, setAllDevices] = useState([]);
    const [searchParams, setSearchParams] = useSearchParams();

    const searchUnit = searchParams.get('unit');
    let defaultUnit = allUnits[0];
    if (searchUnit) {
        defaultUnit = allUnits.find(({value}) => searchParams.get('unit') === value) || defaultUnit;
    }
    const [unit, setUnit] = useState(defaultUnit);
    const [activeDef, setActiveDef] = useState(returnActiveDef(defaultUnit.value) || []);
    let navigate = useNavigate();

    // const [data, {isLoading}] = useDataWithRoute(`/api/v6/report/kubernetes_all_units_proc?client_id=${client.clientId}&period_id=${periodId}`);
    const [data, {isLoading}] = useDataWithRoute(`/api/v6/report/kubernetes_all_units_proc?client_id=${client.clientId}`);

    useEffect(() => {
        const allUnitsData = (data?.recordsets?.[unit.recordset] || []);
        setActiveDef(returnActiveDef(unit.value))
        setAllDevices(allUnitsData);
    }, [data, unit]);

    const onUnitChange = (selectedUnit) => {
        setUnit(selectedUnit);
        setSearchParams({
            unit: selectedUnit.value,
        }, {replace: true});
    };

    const onRowClick = (e) => {
        switch (unit.value) {
            case "clusters":
                navigate(`/reports/kubernetes/cluster/cluster-overview?cluster_name=${encodeURI(e.data.cluster_name)}&period_id=${periodId}`);
                break;
            case "nodes":
                navigate(`/reports/kubernetes/node/node-status?node_name=${encodeURI(e.data.node_name)}&period_id=${periodId}`);
                break;
            default:
            // do nothing
        }
    }

    const gridText = () => {
        if(unit.value === "clusters" || unit.value === 'nodes') {
            return `Double click to see detailed ${unit.value.slice(0, unit.value.length - 1)} reports`;
        }
    }

    return <Card className={`report-card p-2 nav-card-${theme}`}>
        <VsiH4>All Units - {unit.label}</VsiH4>
        <VsiBubble noAutobot>
            <VsiLabeledSelect options={allUnits}
                              isLoading={isLoading}
                              label={'Select Unit'}
                              onChange={onUnitChange}
                              defaultValue={unit}/>
        </VsiBubble>
        {isLoading ? <Spinner color={"primary"}/> : (
            <VsiBubble unit={unit.label}>
                <Grid data={allDevices}
                    isLoading={isLoading}
                    columnDefs={activeDef}
                    saveParams={{
                        unit: unit.value,
                    }}
                    rowDoubleClicked={onRowClick}
                    gridText={gridText()}/>
            </VsiBubble>
        )}
    </Card>
}
